import React, { Component } from 'react';
import { HeatMapGrid } from 'react-grid-heatmap';
import './styles/map.css';
//import { useFormik } from 'formik';


const baseUrl= process.env.REACT_APP_HOST

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

function getObservationDataArray (observerJSONList, observerNames){
  const observationData = Array.from(Array(observerNames.length), () => new Array(7));
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

            for (let i = 0; i < observerJSONList.length; i++){
                for (let j = 0; j < observerNames.length; j++){
                    if (observerJSONList[i].ObserverID === observerNames[j]){
                        let convertDate = days[new Date(observerJSONList[i].DateObserved).getDay()]
                        let day = days.indexOf(convertDate);
                        observationData[j][day] = observerJSONList[i].count;
                        break;
                    }
                }
            }

            populateObservationDataZeros(observationData);

  return observationData;
}

//enters zeros if no observations for given week day
function populateObservationDataZeros (observationData){
  for (let r = 0; r < observationData.length; r++){
    for (let c = 0; c < observationData[0].length; c++){
        if (observationData[r][c] == null){
            observationData[r][c] = 0;
        }
    }
  }
}
class ObservationHeatMap extends Component {
  
    state = {
        observerNames: [],
        observationData: [],
        sundays: [],
        isLoaded: false
    }

    async componentDidMount(){

        try{
          const observerNamesResponse = await fetch (baseUrl+'getObserverNames');
          const observerNamesJSONList = await observerNamesResponse.json();

          const observerNames = observerNamesJSONList.map(observer => observer.ObserverID);

          this.setState({observerNames: observerNames, isLoaded: true})
        
        }catch(err){
          this.setState({isLoaded: false});
          console.log("Error fetching data from GET OBSERVER NAMES: " + err);
        }

        try{
            const observerObservationsCountResponse = await fetch (baseUrl+'getObservationsAndObservers');
            const observerJSONList = await observerObservationsCountResponse.json();
            const {observerNames} = this.state;

            const observationData = getObservationDataArray(observerJSONList, observerNames);

            this.setState({observationData: observationData, isLoaded: true});
          
        }catch(err){
            this.setState({isLoaded: false});
            console.log("Error fetching data from GET OBSERVATIONS AND OBSERVERS: " + err);
        }        

    }

    render() {

        const {observationData, observerNames, isLoaded} = this.state;

        return (
            <div className="heatMap">
                 <h1 class="display-3 text-center">Weekly Observations Heat Map</h1>
            <p class="paragraph-center mt-3">This map shows the total number of observations for each observer in the previous week.</p>
            <p class="paragraph-center mb-5">Observation totals are updated every Sunday.</p>
            <div className="heatMapContainer"
              style={{
                width: '100%'
              }}
            >
              {!isLoaded ? <div>Loading...</div> :
              <HeatMapGrid
                data={observationData}
                xLabels={weekDays}
                yLabels={observerNames}
                // Reder cell with tooltip
                cellRender={(x, y, value) => (
                  <div title={`Pos(${x}, ${y}) = ${value}`}>{value}</div>
                )}
                xLabelsStyle={() => ({
                  color: '#777',
                  fontSize: '.8rem'
                })}
                yLabelsStyle={() => ({
                  fontSize: '.7rem',
                  textTransform: 'uppercase',
                  color: '#777'
                })}
                cellStyle={(_x, _y, ratio) => ({
                  background: `rgb(12, 160, 44, ${ratio})`,
                  fontSize: '.8rem',
                  color: `rgb(0, 0, 0, ${ratio / 2 + 0.4})`
                })}
                cellHeight='5rem'
                xLabelsPos='bottom'
                onClick={(x, y) => alert(`${observerNames[x]} had ${observationData[x][y]} observations on ${weekDays[y]}`)}
                yLabelsPos='left'
                square
              />
              }
              </div>
            </div>
          )
    }
    
}

export default ObservationHeatMap;